export default __webpack_public_path__ + "static/media/gilroy-regular-3.86bc2a5a.otf";